import {Permissions, RoleData} from "@/enums/user";

export type NavAccessFields = {
  dataType: RoleData;
  additionalDataTypes?: readonly RoleData[];
  levels?: readonly Permissions[];
};

export function navAccessLevels(item: NavAccessFields): readonly Permissions[] {
  return item.levels?.length ? item.levels : [Permissions.Read];
}

/** True when any of the item's data types is held at any of its levels. */
export function canAccessNavItem(
  item: NavAccessFields,
  canAccessAny: (dataTypes: readonly RoleData[], level: Permissions) => boolean
): boolean {
  const dataTypes = [item.dataType, ...(item.additionalDataTypes ?? [])];
  return navAccessLevels(item).some((level) => canAccessAny(dataTypes, level));
}
